import {
  CUBE_LAYER_REMOVAL_BLOCKED_ERROR_CODE,
  CubeLayerRemovalBlockedErrorResponse,
} from 'types/api/SystemTenant/AROCube/CubeLayerSetTypes';

interface ErrorResponseLike {
  response?: {
    status?: number;
    data?: unknown;
  };
}

function getErrorResponse(error: unknown) {
  return (error as ErrorResponseLike | null | undefined)?.response;
}

export function getCubeLayerRemovalBlockedError(error: unknown): CubeLayerRemovalBlockedErrorResponse | null {
  const response = getErrorResponse(error);
  const data = response?.data as Partial<CubeLayerRemovalBlockedErrorResponse> | null | undefined;

  if (
    response?.status !== 409 ||
    data?.code !== CUBE_LAYER_REMOVAL_BLOCKED_ERROR_CODE ||
    !data.details ||
    typeof data.details.layerId !== 'string' ||
    typeof data.details.layerName !== 'string' ||
    !Array.isArray(data.details.dependencies)
  ) {
    return null;
  }

  return data as CubeLayerRemovalBlockedErrorResponse;
}

/**
 * Older servers only returned a sentence for this conflict. Recognise it so the user still gets a
 * blocking, recoverable error without attempting to extract identifiers or dependency data from text.
 */
export function isLegacyCubeLayerRemovalBlockedError(error: unknown) {
  const response = getErrorResponse(error);
  const data = response?.data as { message?: unknown } | null | undefined;

  return (
    response?.status === 409 &&
    typeof data?.message === 'string' &&
    data.message.toLowerCase().startsWith('cannot remove layer from cube')
  );
}
